/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал домофонного звонка
 */

/**
 * Сервис управления домофонными звонками
 */
export class CallServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод обработки события звонка с домофона.
   * Метод доступен для: ApiKey
   */
  PostCall = (req: PostCallRequestDto, init?: RequestInit): Promise<PostCallResponseDto> => {
    return fm.request<PostCallRequestDto, PostCallResponseDto>(`${this.host}/dial/internal/api/v1/call`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод обработки события об окончании группового звонка с домофона.
   * Метод доступен для: ApiKey
   */
  PostCallCancel = (req: PostCallCancelRequestDto, init?: RequestInit): Promise<PostCallCancelResponseDto> => {
    return fm.request<PostCallCancelRequestDto, PostCallCancelResponseDto>(`${this.host}/dial/internal/api/v1/call_cancel`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на передачу события об окончании группового звонка с домофона
 */
export type PostCallCancelRequestDto = {
  /**
   * СИП-аккаунт устройства
   */
  sipAccount: string
}
/**
 * Ответ на запрос на передачу события об окончании группового звонка с домофона
 */
export type PostCallCancelResponseDto = {
}
/**
 * Запрос на передачу события звонка с домофона
 */
export type PostCallRequestDto = {
  /**
   * Вызываемый номер.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  toNumber: string
  /**
   * Вызывающий номер.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  fromNumber: string
}
/**
 * Ответ на запрос на передачу события звонка с домофона
 */
export type PostCallResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на передачу события об окончании группового звонка с домофона
   */
  "PostCallCancelRequest": {
    "kind": "class",
    "text": "Запрос на передачу события об окончании группового звонка с домофона",
    "fields": {
      /**
       * СИП-аккаунт устройства
       */
      "sipAccount": {
        "type": "string",
        "text": "СИП-аккаунт устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на передачу события об окончании группового звонка с домофона
   */
  "PostCallCancelResponse": {
    "kind": "class",
    "text": "Ответ на запрос на передачу события об окончании группового звонка с домофона",
  },
  /**
   * Запрос на передачу события звонка с домофона
   */
  "PostCallRequest": {
    "kind": "class",
    "text": "Запрос на передачу события звонка с домофона",
    "fields": {
      /**
       * Вызываемый номер.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "toNumber": {
        "type": "string",
        "text": "Вызываемый номер.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
      /**
       * Вызывающий номер.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "fromNumber": {
        "type": "string",
        "text": "Вызывающий номер.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
    },
  },
  /**
   * Ответ на запрос на передачу события звонка с домофона
   */
  "PostCallResponse": {
    "kind": "class",
    "text": "Ответ на запрос на передачу события звонка с домофона",
  },
}